import { useMutation, useQueryClient } from "@tanstack/react-query";
import { uploadMRDCCheck } from "@/api/v1-jwt/mrdc/mrdc";

export const useUploadCheck = () => {
  const query = useQueryClient();

  return useMutation({
    mutationFn: uploadMRDCCheck,
    onSuccess: () => {
      query.invalidateQueries(["mrdc"]);
    },
  });
};
